import { cn } from "~/lib/utils";
import { Button } from "./ui/button";
import { Link } from "@tanstack/react-router";

export function ButtonLink({
  to,
  children,
  className,
}: {
  to: string;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <Button className={cn("w-full bg-primary", className)} asChild>
      {/* @ts-ignore */}
      <Link to={to}>{children}</Link>
    </Button>
  );
}
